export const subscribeEmail = async(email) => { 
  const res = await fetch("/.netlify/functions/emailSubscribe", {
    method: 'POST',
    body: JSON.stringify({email: email})
  })
  return res.json();
}
